export default __webpack_public_path__ + "static/media/sampleInvoicePDF.c6373843.pdf";